// Products State

export default {
  productsList: [],
  productInfo: {},
  fullProductsList: [],
  fullSaleProductsList: [],
  fullPurchaseProductsList: []
}
